export default {"src":"/_next/static/media/ic_insta.74d2ff5d.svg","height":20,"width":20};